import { render, staticRenderFns } from "./ProtectionJuridique.vue?vue&type=template&id=4220a76a&scoped=true&"
import script from "./ProtectionJuridique.vue?vue&type=script&lang=js&"
export * from "./ProtectionJuridique.vue?vue&type=script&lang=js&"
import style1 from "./ProtectionJuridique.vue?vue&type=style&index=1&id=4220a76a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4220a76a",
  null
  
)

export default component.exports